import React from 'react';
import YoutubePlayer from '../../common/YoutubePlayer';
import ProgressiveImage from 'react-progressive-image';
import { getTheBestImageFormat } from '../../utils/common';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal({ closeModal }) {
	return (
		<div className='project-popup'>
			<h1 className='project-popup__title'>Acroplia</h1>
			<div className='project-popup__description'>
				Acroplia is an extensive and feature-rich communication, collaboration, and
				community platform for teams, families, and online learning. Any user can
				sign in to Acroplia and invite colleagues from any corner of the planet to
				meetings and various collaborations. <br /> <br />
				Acroplia is an all-in-one platform, and it consists of multiple modules:{' '}
				<br /> <br />
				<ul className='project-popup-list'>
					<li className='project-popup-list__item'>
						<h4 className='project-popup-list__item-title'>1) Video conferencing</h4>
						<p className='project-popup-list__item-text'>
							Teams can have big-group video calls while collaborating on their
							documents. Also, they can schedule the calls, share the screens, send
							the current call to another device (Mobile app), adapt the view and
							size of the call window, etc.
						</p>
						<div className='project-popup__videos'>
							<YoutubePlayer
								src='https://www.youtube.com/embed/L7W-Ua2dA9E'
								title='Collaboration platform (Calls)'
							/>
						</div>
					</li>
					<li className='project-popup-list__item'>
						<h4 className='project-popup-list__item-title'>2) Chats</h4>
						<p className='project-popup-list__item-text'>
							Acroplia includes feature-rich P2P and group chats. One can go beyond
							chats with easy access to calling tools and collaborative documents.
						</p>
						<div className='project-popup__videos'>
							<YoutubePlayer
								src='https://www.youtube.com/embed/Z-42EAMyGTw'
								title='Collaboration platform (Chats)'
							/>
						</div>
					</li>
					<li className='project-popup-list__item'>
						<h4 className='project-popup-list__item-title'>3) Notes</h4>
						<p className='project-popup-list__item-text'>
							Feature-rich and real-time collaborative text editor based on Quill.js.
							Users can control access to all notes by sharing them with specific
							members, rooms, and communities or keeping them in a personal library.
						</p>
						<div className='project-popup__videos'>
							<YoutubePlayer
								src='https://www.youtube.com/embed/7WU4GR0aUGs'
								title='Collaboration platform (Notes)'
							/>
						</div>
					</li>
					<li className='project-popup-list__item'>
						<h4 className='project-popup-list__item-title'>
							4) Ideaboard and PDF board
						</h4>
						<p className='project-popup-list__item-text'>
							Collaborative canvas ideaboard based on Konva.js. Users can work on PDF
							files - insert screenshots and videos and draw together in real-time on
							one whiteboard.
						</p>
						<div className='project-popup__videos'>
							<YoutubePlayer
								src='https://www.youtube.com/embed/Wh0VdgdVMQY'
								title='Collaboration platform (Ideaboard and PDF board)'
							/>
						</div>
					</li>
					<li className='project-popup-list__item'>
						<h4 className='project-popup-list__item-title'>5) Acroplia Drive </h4>
						<p className='project-popup-list__item-text'>
							One place to store all documents and files. Users can create and add
							new Acroplia documents in Drive (Note, Idea-board, PDF-board, Quest,
							Task list) or drag and drop files or folders from their computers. All
							hierarchy will be saved.
						</p>
						<div className='project-popup__videos'>
							<YoutubePlayer
								src='https://www.youtube.com/embed/-rX7KCzySKU'
								title='Collaboration platform (Ideaboard and PDF board)'
							/>
						</div>
					</li>
					<li className='project-popup-list__item'>
						<h4 className='project-popup-list__item-title'>6) Quests</h4>
						<p className='project-popup-list__item-text'>
							Quests are a great way to learn vocabulary while learning a new
							language or learning new facts. Users can create cards with questions
							and answers with attached images and audio and then practice these
							cards to memorize. Fully collaborative, like everything in Acroplia.
						</p>
						<ProgressiveImage
							src={getTheBestImageFormat({
								webp: './media/projects/acroplia/quests/quests.webp',
								backupImage: './media/projects/acroplia/quests/quests.png',
							})}
							placeholder='./media/loader.gif'
						>
							{(src) => <img src={src} alt='Acroplia quests' />}
						</ProgressiveImage>
					</li>
					<li className='project-popup-list__item'>
						<h4 className='project-popup-list__item-title'>7) Task manager</h4>
						<p className='project-popup-list__item-text'>
							Own collaborative tool for creating, prioritizing, tracking tasks, and
							distributing them across the team.
						</p>
					</li>
					<li className='project-popup-list__item'>
						<h4 className='project-popup-list__item-title'>8) Calendar</h4>
						<p className='project-popup-list__item-text'>
							Tool for creating, viewing, and managing events and scheduled calls.
						</p>
						<ProgressiveImage
							src={getTheBestImageFormat({
								webp: './media/projects/acroplia/calendar/calendar.webp',
								backupImage: './media/projects/acroplia/calendar/calendar.png',
							})}
							placeholder='./media/loader.gif'
						>
							{(src) => <img src={src} alt='Acroplia calendar' />}
						</ProgressiveImage>
					</li>
				</ul>
				I joined Acroplia (<a href='https://www.gxbventures.com'>GXB Ventures</a>) as
				a Senior frontend developer (React, Redux + Node.js for SSR) about two years
				after the project's foundation. <br />
				We worked on Acroplia in a team of ~ 25 people: front-end developers (React -
				redux) of various levels (8 devs), backend developers (Kotlin - Spring
				framework), DevOps, designers, QA team, managers, mobile developers
				(react-native) and others. <br />
				Then after eight months of work, I took the position of frontend technical
				lead. <br />
				<br />
				Mainly I was responsible for the following:
				<ul className='project-popup-list project-popup-list--disc'>
					<li className='project-popup-list__item'>
						<p className='project-popup-list__item-text'>
							Frontend part of Acroplia: bug fixes, new features, rendering and
							loading performance optimizations, refactoring, technical solutions
						</p>
					</li>
					<li className='project-popup-list__item'>
						<p className='project-popup-list__item-text'>
							Code review and help to other developers
						</p>
					</li>
					<li className='project-popup-list__item'>
						<p className='project-popup-list__item-text'>
							Tasks estimation and assistance to managers in the preparation of
							sprints
						</p>
					</li>
					<li className='project-popup-list__item'>
						<p className='project-popup-list__item-text'>
							Conducting technical interviews with frontend candidates
						</p>
					</li>
				</ul>
				One of my final tasks was rewriting the existing monolith Kotlin backend to a
				new micro-services Node.js backend with the usage of Nest.js framework and
				TypeScript. And then integration of new micro-services backend to the
				existing frontend.
			</div>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<br />
					<span className='span-description '>
						React.js, Redux, webpack, Node.js (SSR), Redis, websockets, AWS, Docker,
						Jitsi (Video conferencing), Quill.js (Notes), Konva.js (Canvas
						ideaboard), MaterialUI, Storybook (tool for UI development), etc. <br />
						Acroplia Drive backend: Node.js, Mongo.db (Mongoose) <br />
						Micro-services Node.js backend: Nest.js + TypeScript, GRPC, RabbitMQ,
						TypeORM
					</span>
				</p>
			</div>
			<div className='project-popup__buttons '>
				<CloseModalButton onClose={closeModal} />
			</div>
		</div>
	);
}
